import React from 'react';
import { getIn, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { StyledFieldError } from './FieldError.styles';

interface IProps {
  name: string;
}

export const FieldError = ({ name }: IProps) => {
  const form = useFormikContext();
  const fieldError = getIn(form.errors, name);
  if (!fieldError) return null;

  return (
    <StyledFieldError id={`error_${name}`}>
      <FontAwesomeIcon icon={faExclamationCircle} />
      <span>{fieldError}</span>
    </StyledFieldError>
  );
};
